import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Link
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import { creditAssessmentFields } from "assets/properties/properties";
import { formatAmount } from "utils/Utils";
import { toCamelCase } from "utils/Utils";
import { familyDetailsFields } from "assets/properties/properties";
import ViewImageModal from "../pages/FieldAgent/ViewImage/ViewImageModal";
import CibilObligationsDialog from "../pages/FieldAgent/Ornamentv2/LoanDetailsCreditAssessment/CibilObligationsDialog";
import { parseAndSetFlag } from "utils/Utils";
import { dataMapLabels } from "assets/properties/properties";

const FamilyDetailsReview = ({ loanApplicationId, classes, showAttachement, featureFlags }) => {
    const [familyList, setFamilyList]=useState([])
    const [creditAssessmentData, setCreditAssessmentData]=useState({})
    const [additionalIncomeList, setAdditionalIncomeList] = useState([]);
    const { authToken } = useSelector((state) => state.login.authData);
    const [imageUrl, setImageUrl]=useState("");
    const [viewImageModal, setViewImageModal]=useState(false)
    const [cibilDialogOpen, setCibilDialogOpen] = useState(false);
    const [cibilObiligationsData, setCibilObiligationsData] = useState([]);
    const enabledCreditAssessmentOnLoanDetails = parseAndSetFlag(featureFlags?.enabledCreditAssessmentOnLoanDetails);
    const fetchFamily = async () => {
        const res = await apiHandler({
          url: `${endpoint.FAMILY_DETAIL_BASE_URL}/${loanApplicationId}/find`,
          method: "GET",
          authToken,
        });
        if (res?.data?.length > 0) {
            setFamilyList(res?.data)
        }
         await getCreditAssessmentLetter();
    }
      useEffect(() => {
        fetchFamily();
      }, []);

  const getCreditAssessmentLetter = async () => {
    const result = await apiHandler({
      url: endpoint.CREDIT_ASSESSMENT_DATA_FIND + loanApplicationId,
      authToken,
    });
    if (!result?.data?.error_code) {
      const data = result?.data;
      if(enabledCreditAssessmentOnLoanDetails){
        await getCibilObligation();
      }
      setCreditAssessmentData(data);
      if (
        Array.isArray(data?.additionalDetails) &&
        data?.additionalDetails?.length
      ) {
        setAdditionalIncomeList(
          data?.additionalDetails?.map((item) => ({
            additionalSource: item.name,
            additionalIncome: item.amount,
            address: item?.address,
            attachment:item?.attachment,
            attachmentType:item?.attachmentType,
          }))
        );
      }
    }
  };
  const getCibilObligation = async () => {
      const res = await apiHandler({
        url: endpoint.GET_CIBIL_OBILIGATION_DETAILS + loanApplicationId,
        method: "GET",
        authToken: authToken,
      });
      if (!res?.data?.error_code) {
        setCibilObiligationsData(res?.data?.applicantCibilScoreDetail?.rawResponse?.data?.obligations);
      }
    }
    const openImage = (url) => {
    setImageUrl(url);
    setViewImageModal(true);
  };
  const itemView = (label, value) => {
    return (
      <Grid item xs={5} sm={6} md={3} className={classes.fieldContaienrReview}>
        <p style={{ marginBottom: 0 }}>
          <b>{label}</b>
        </p>
        <label>{value || "NA"}</label>
      </Grid>
    );
  };

  return (
    <div>
      <Grid container>
        <Grid item xs={12} className={classes.inputFieldContainer}>
          <h2 className={classes.header} style={{ fontSize: "1.5rem" }}>
            Credit Assessment Details
          </h2>
        </Grid>
      </Grid>

      <Grid item xs={12} className={classes.inputFieldContainer}>
        <GridContainer>
          {creditAssessmentData?.purposeOfLoan && itemView(
            creditAssessmentFields.purposeOfLoan,
            creditAssessmentData?.purposeOfLoan
          )}
            {creditAssessmentData?.purposeOfLoanSubCategory && itemView(
            creditAssessmentFields.purposeOfLoanType,
            creditAssessmentData?.purposeOfLoanSubCategory
          )}

          {Number(creditAssessmentData?.householdExpenses) > 0 && itemView(
            creditAssessmentFields.householdExpenses,
            formatAmount(creditAssessmentData?.householdExpenses)
          )}

          {creditAssessmentData?.annualIncome && itemView(
            creditAssessmentFields.annualIncome,
            formatAmount(creditAssessmentData?.annualIncome)
          )}
          {Number(creditAssessmentData?.creditScore) > 0 &&
          itemView(
            creditAssessmentFields.creditScore,
            creditAssessmentData?.creditScore
          )}
         {Number(creditAssessmentData?.existingMonthlyEmiObligation) > 0 &&
          itemView(
            creditAssessmentFields.EmiObligation,
            formatAmount(creditAssessmentData?.existingMonthlyEmiObligation)
          )}
          {Object.entries(creditAssessmentData?.dataMap || {}).map(
            ([key, value]) =>
              value != null &&
              value !== "" &&
              Number(value) > 0 &&
              itemView(
                dataMapLabels[key] || key,
                formatAmount(value)
              )
          )}
          {cibilObiligationsData?.length > 0 &&
          itemView(
            creditAssessmentFields.cibilObligations,
            <Link
              component="button"
              variant="body2"
              onClick={() => setCibilDialogOpen(true)}
              style={{
                marginTop: 6,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              View Obligations
            </Link>
            )
          }
         {Number(creditAssessmentData?.currentLoanInterest) > 0 &&
          itemView(
            creditAssessmentFields.currentInterest,
            formatAmount(creditAssessmentData?.currentLoanInterest)
          )}
         {Number(creditAssessmentData?.totalOutstandingAmount) > 0 &&
          itemView(
            creditAssessmentFields.totalOutstading,
            formatAmount(creditAssessmentData?.totalOutstandingAmount)
          )}
          {Number(creditAssessmentData?.prevLoanInterest) > 0 &&
          itemView(
            creditAssessmentFields.prevInterest,
            formatAmount(creditAssessmentData?.prevLoanInterest)
          )}

          {additionalIncomeList?.length > 0 && <Box mt={2} style={{ width: "100%" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>{creditAssessmentFields?.additionSource}</strong>
                  </TableCell>
                  <TableCell>
                    <strong>{creditAssessmentFields?.additionalAmount}</strong>
                  </TableCell>
                  <TableCell>
                    <strong>{creditAssessmentFields?.address}</strong>
                  </TableCell>
                  <TableCell>
                    <strong>{creditAssessmentFields?.attachementType}</strong>
                  </TableCell>
                    <TableCell>
                    <strong>{creditAssessmentFields?.attachment}</strong>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {additionalIncomeList?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.additionalSource}</TableCell>
                    <TableCell>{formatAmount(item.additionalIncome)}</TableCell>
                    <TableCell>{item.address}</TableCell>
                    <TableCell>{item.attachmentType}</TableCell>
                    {item?.attachment && <TableCell> <Button
                      variant="contained"
                      className={classes.nextButton}
                      onClick={() => openImage(item.attachment)}
                      style={{ margin: "0 15%" }}
                    >
                      View
                    </Button></TableCell>}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>}
          {familyList?.length > 0 && <Grid container>
            <Box mt={2} style={{ width: "100%" }}>
              <Typography
                variant="subtitle1"
                style={{ fontWeight: 600, marginBottom: 12, marginLeft:'1.5%'  }}
              >
                {familyDetailsFields?.header}
              </Typography>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong>{familyDetailsFields?.name}</strong>
                    </TableCell>
                    <TableCell>
                      <strong>{familyDetailsFields?.relationship}</strong>
                    </TableCell>
                    <TableCell>
                      <strong>{familyDetailsFields?.number}</strong>
                    </TableCell>
                    <TableCell>
                      <strong>{familyDetailsFields?.income}</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {familyList?.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.name}</TableCell>
                      <TableCell>{toCamelCase(item.relationship)}</TableCell>
                      <TableCell>{item.mobileNumber}</TableCell>
                      <TableCell>{item.income}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Grid>}
          {viewImageModal && (
            <ViewImageModal
              showModal={viewImageModal}
              closeModal={() => setViewImageModal(false)}
              imageUrl={imageUrl}
            />
            )}
        </GridContainer>
      </Grid>
      {cibilDialogOpen &&
        <CibilObligationsDialog
          open={cibilDialogOpen}
          onClose={() => setCibilDialogOpen(false)}
          obligations={cibilObiligationsData}
        />
      }
    </div>
  );
};

export default FamilyDetailsReview;